import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconRetryStyle0 = gravityIconIndividualCss;

const GravityIconRetry = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '98b1ba948efd82092be4871cb6a9a5a255a166a4', color: this.color, size: this.size }, h("svg", { key: '9d5f33ab9fb7ce4945c6c4b845fb379467809b2c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '93b04e3928430efe97c743fa09304d6e6f797757', d: "M5.904 15.596a6.5 6.5 0 0 0 8.825.34.532.532 0 0 1 .72.014l.354.353a.477.477 0 0 1-.01.697 8 8 0 1 1 .364-11.657l1.638 1.638 1.555-1.55a.4.4 0 0 1 .686.276v4.242a.4.4 0 0 1-.396.396h-4.243a.4.4 0 0 1-.283-.693l1.618-1.612-1.636-1.636a6.5 6.5 0 1 0-9.192 9.192Z", fill: "currentColor" }))));
    }
};
GravityIconRetry.style = GravityIconRetryStyle0;

export { GravityIconRetry as gravity_icon_retry };

//# sourceMappingURL=gravity-icon-retry.entry.js.map